import { ChangeDetectionStrategy, Component, ElementRef, ViewChild } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-reordered-row-cell-flag',
  imports: [MatIcon],
  templateUrl: './reordered-row-cell-flag.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: `
    :host {
      height: 100%;
      display: flex;
      align-items: center;
    }
  `,
})
export class ReorderedRowCellFlagComponent
  implements ICellRendererAngularComp {
  public isReordered = true;
  public canReorder = true;
  private cellRendererParams!: ICellRendererParams;

  @ViewChild('dragRef', { read: ElementRef })
  private set dragRef(container: ElementRef) {
    if (container) {
      this.cellRendererParams.registerRowDragger(container.nativeElement);
    }
  }


  public agInit(params: ICellRendererParams): void {
    this.cellRendererParams = params;
    this.isReordered = params.value;
    this.canReorder = params?.context?.canReorder ?? this.canReorder;
    console.log({ params });
  }

  public refresh(params: ICellRendererParams): boolean {
    this.isReordered = params.value;
    return false;
  }
}
